import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import styles from './CheckBox.module.css';

const checkIcon = require('./imgs/check.svg');

// Generate unique ID
let idCounter = 0;
// eslint-disable-next-line no-plusplus
const generateId = (prefix) => `${prefix}-${++idCounter}-${Math.random().toString(36).substr(2, 9)}`;

const CheckBox = ({
  label,
  isChecked,
  onClick,
  isRequired,
  ariaDescribedBy,
  ariaLabelledby,
  ariaLabel,
  checkIconSrc
}) => {
  const labelIdRef = useRef(generateId('checkbox-label'));
  const resolvedCheckIconSrc =
    typeof checkIconSrc === 'string'
      ? checkIconSrc
      : checkIconSrc?.default || checkIconSrc;
  const iconSrc = resolvedCheckIconSrc || checkIcon;
  const useBrandCheck = Boolean(resolvedCheckIconSrc);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  const ariaLabelledbyResolved =
    ariaLabelledby ||
    (label && !ariaLabel ? labelIdRef.current : undefined);

  const boxClassName = useBrandCheck
    ? [
        styles.brandCheckBox,
        isChecked ? styles.brandCheckBoxChecked : null,
      ]
        .filter(Boolean)
        .join(' ')
    : [
        isChecked ? styles.isChecked : null,
        'border-[1px] border-border dark:border-button',
        isChecked ? 'bg-border dark:bg-button' : null,
      ]
        .filter(Boolean)
        .join(' ');

  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    <div
      className={`${styles.checkBoxWrapper} flex gap-3 items-center`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="checkbox"
      aria-checked={isChecked}
      aria-label={ariaLabel || undefined}
      aria-labelledby={ariaLabelledbyResolved}
      aria-describedby={ariaDescribedBy || undefined}
      aria-required={isRequired ? true : undefined}
      tabIndex={0}
    >
      <div className={boxClassName} aria-hidden="true">
        <img
          alt=""
          src={iconSrc}
          className={`${isChecked ? 'block' : 'hidden'}${
            useBrandCheck ? ` ${styles.brandCheckIcon}` : ''
          }`}
          aria-hidden="true"
        />
      </div>
      {label ? (
        <span id={labelIdRef.current} className='text-dark dark:text-white'>
          {label}
        </span>
      ) : null}
    </div>
  );
};

CheckBox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  ariaLabel: PropTypes.string,
  checkIconSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};

CheckBox.defaultProps = {
  isChecked: false,
  label: null,
  isRequired: undefined,
  ariaDescribedBy: undefined,
  ariaLabelledby: undefined,
  ariaLabel: undefined,
  checkIconSrc: undefined
};
export default CheckBox;
